module.exports = __webpack_public_path__ + "static/img/shangchuanchangjingtu.d6c9adf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/shangchuanchangjingtu.png
// module id = rXd+
// module chunks = 24